export enum ProductFeatureType {
    AchExceptions = 'AchExceptions',
    Arp = 'Arp',
    WireTransfer = 'WireTransfer',
    WireTransferDomestic = 'WireTransferDomestic',
    WireTransferInternational = 'WireTransferInternational',
    PositivePay = 'PositivePay',
    TransferLoanPayment = 'InternalTransfer',
    AccountReconciliation = 'AccountReconciliation',
    StopPayment = 'StopPayment',
    IntegratedServices = 'IntegratedServices',
    InformationReporting = 'InformationReporting',
    FxWire = 'FxWire',
    Receivables = 'Receivables',
}

export type ProductFeatureEntitlementTypes = Exclude<
    ProductFeatureType,
    ProductFeatureType.WireTransfer
>;
export type ProductFeatureLimitTypes = Exclude<
    ProductFeatureType,
    ProductFeatureType.WireTransferDomestic | ProductFeatureType.WireTransferInternational
>;
